<template>
  <section>
    <div>
      <ul>
        <li v-if="success">
          <p>{{ $t('contact.success') }}</p>
          <rent-button @buttonclicked="redirectToHome">
            Retour à l'Accueil
          </rent-button>
        </li>
        <li v-else>
          <p>{{ $t('contact.error') }}</p>
          <rent-button @buttonclicked="redirectToHome">
            Retour à l'Accueil
          </rent-button>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import RentButton from '../shared/RentButton';

export default {
  props: {
    success: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    RentButton,
  },

  methods: {
    redirectToHome() {
      window.location = '/';
    },

  },
}
</script>

<style lang="scss" scoped>

section {
  align-content: center;
  align-items: center;
  align-self: center;
  display: flex;
  min-height: calc(100vh - 300px);
}

div {
  display: flex;
  flex-direction: column;
  padding: 15px;
}

ul {
  border: 1px solid $desert-storm;
  color: black;
  display: flex;
  max-width: 585px;
  padding: 15px;
}

li {
  display: flex;
  flex: 1;
  flex-direction: column;
}

h5 {
  font-family: $f-graphie-bold;
  margin: 0 0 10px;
}

span {
  @include font-size(11);

  display: block;
  margin: 10px 0 0;
}
</style>
